import _objectSpread from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.index-of.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import Components from "./lenti/index";

var Lenti = /*#__PURE__*/function (_Vue) {
  _inherits(Lenti, _Vue);

  var _super = _createSuper(Lenti);

  function Lenti() {
    _classCallCheck(this, Lenti);

    return _super.apply(this, arguments);
  }

  _createClass(Lenti, [{
    key: "tipoLenti",
    get: // rifCliente: string = "";
    function get() {
      return this.$store.state.configurator.glassType;
    }
  }, {
    key: "lentiSole",
    get: function get() {
      return this.$store.getters["configurator/lenti/sunLenses"];
    }
  }, {
    key: "lenteSole",
    get: function get() {
      return this.$store.state.configurator.lenteSole;
    }
  }, {
    key: "note",
    get: function get() {
      return this.$store.state.configurator.note;
    },
    set: function set(n) {
      this.$store.commit("configurator/setRowNotes", n); // this.$store.commit("configurator/setRowNotes", `Rif. ${n}`);
    }
  }, {
    key: "calibro",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.calibro);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "naso",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.naso);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "setRowNotes",
    value: function setRowNotes(n) {
      this.$store.commit("configurator/setRowNotes", n);
    }
  }, {
    key: "rif",
    value: function rif(val) {
      if (val.indexOf("Rif.") < 0 && this.note != "") {
        this.setRowNotes("Rif. ".concat(val));
      }
    }
  }, {
    key: "setSunLensesModel",
    value: function setSunLensesModel(l) {
      this.$store.commit("configurator/setSunLensesModel", l);
    }
  }, {
    key: "lensImageUrl",
    value: function lensImageUrl(lens) {
      return process.env.VUE_APP_COLORS_URL + lens.ItemCode + ".jpg";
    }
  }, {
    key: "resetRowNotes",
    value: function resetRowNotes() {
      this.$store.commit("resetRowNotes");
    }
  }]);

  return Lenti;
}(Vue);

Lenti = __decorate([Component({
  components: _objectSpread({}, Components)
})], Lenti);
export default Lenti;